module.exports = __webpack_public_path__ + "img/1480602535.ea528d5f.jpg";